import InputWrapper from "../../../../../../components/input/wrapper/InputWrapper";
import Select from "../../../../../../components/select/main/Select";
import { useLanguageContext } from "../../../../../../context/LanguageContext";
import EVAApiHelper from "../../../../../../helpers/EVAApiHelper";
import { StyledInput } from "../../../../../../styles/InputStyles";
import { StyledFlexColumn } from "../../../../../../styles/LayoutStyles";

function HouserulesFormView({
  relations,
  selectedStep,
  selectedStepIndex,
  onHouserulesChange,
  onHouserulesExpirationChange,
  submitError,
}) {
  const { translate } = useLanguageContext();

  return (
    <StyledFlexColumn>
      <InputWrapper
        label={translate("eva.main.validation.attributes.steps.*.file_id")}
        required
        error={EVAApiHelper.getResponseError(
          `steps.${selectedStepIndex}.file_id`,
          submitError,
        )}
      >
        <Select
          value={selectedStep?.file_id}
          options={relations?.files?.records
            ?.filter((file) => file.type === "houserule")
            ?.map((file) => ({ value: file.id, label: file.name }))}
          onChange={onHouserulesChange}
        />
      </InputWrapper>

      <InputWrapper
        label={translate(
          "eva.main.validation.attributes.steps.*.houserules_expiration",
        )}
        required
        error={EVAApiHelper.getResponseError(
          `steps.${selectedStepIndex}.houserules_expiration`,
          submitError,
        )}
      >
        <StyledInput
          type="number"
          value={selectedStep?.houserules_expiration}
          onChange={onHouserulesExpirationChange}
        />
      </InputWrapper>
    </StyledFlexColumn>
  );
}

export default HouserulesFormView;
